import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { WidgetModule } from './widgets/widget.module';

import { JsonPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SortablejsModule } from 'angular-sortablejs';
import { HighlightJsModule, HighlightJsService } from 'angular2-highlight-js';
import { MomentModule } from 'angular2-moment';
import { FileSelectorComponent } from 'app/components/common/fileSelector/fileSelector.component';
import { ModalModule } from 'app/components/modal/modal.module';
import { SharedModule } from 'app/components/shared.module';
import { PipesModule } from 'app/pipes/pipes.module';
import { PresentationRepository } from 'app/services/database/presentation.repository';
import { ModalService } from 'app/services/modal.service';
import { LayoutModule } from 'app/views/presentations/layouts/layout.module';
import { PresentationsListComponent } from 'app/views/presentations/presentationsList.component';
import { HeaderWidget } from 'app/views/presentations/widgets/header/header.widget';
import { EditPresentationComponent } from './editPresentation.component';

@NgModule({
    declarations: [
        PresentationsListComponent,
        EditPresentationComponent
    ],
    imports: [
        BrowserModule,
        PipesModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        HighlightJsModule,
        TranslateModule,
        TranslateModule,
        MomentModule,
        WidgetModule.forRoot(),
        LayoutModule.forRoot()
    ],
    exports: [
        PresentationsListComponent,
        EditPresentationComponent
    ],
    entryComponents: [
        PresentationsListComponent,
        EditPresentationComponent
    ]
})

export class PresentationsModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: PresentationsModule,
            providers: [
                PresentationRepository,
                HighlightJsService,
                JsonPipe
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/presentations.module.ts